import React from 'react';

import Layout from './components/Layout';
import TimeTrackReports from './timeTrackReport/timeTrackReport';
import Filters from './timeTrackReport/components/TimeTrackingFilterContainer';
import { t } from '../../../modules/infra/i18n';

const TimeTrackReport = () => (
  <Layout title={t('reports:time_track_report.title')}>
    <Filters />
    <TimeTrackReports />
  </Layout>
);

export default TimeTrackReport;
